import VideoCardSkeleton from "./VideoCardSkeleton";

type VideoGridSkeletonProps = {
  count?: number;
};

export default function VideoGridSkeleton({
  count = 8,
}: VideoGridSkeletonProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 sm:gap-6">
      {Array.from({ length: count }).map((_, index) => (
        <VideoCardSkeleton key={index} />
      ))}
    </div>
  );
}
